import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { AnimatedTitle } from "../AnimatedTitle";
import { Reveal } from "../Reveal";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/6de08a343b71cb8de9cccbb460230129fad2274eebb01bc780d0b398cfd66f20.png";

// Encart final « Prêt à rejoindre le réseau ? » — inchangé, tout en bas au-dessus du footer.
export default function JoinFinalCTA({ onJoin, accent = "#C19A6B", ctaImage = HERO_IMG }) {
  const { t } = useTranslation();
  const join = () => onJoin && onJoin();
  return (
    <section className="jc relative px-6 py-28 text-center overflow-hidden" style={{ ["--jc"]: accent }} data-testid="join-final-cta">
      <style>{`.jc .jc-bg{background-color:var(--jc);color:#050505}.jc .jc-bg:hover{filter:brightness(1.1)}`}</style>
      <div className="absolute inset-0 bg-cover" style={{ backgroundImage: `url(${ctaImage})`, backgroundPosition: "center 38%" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(5,5,5,0.82) 0%, rgba(5,5,5,0.7) 100%)" }} />
      <div className="relative z-10">
        <Reveal><AnimatedTitle text={t("join.cta_title")} className="text-2xl md:text-4xl font-light text-white" /></Reveal>
        <Reveal delay={0.15}><p className="text-sm text-zinc-300 mt-4">{t("join.cta_text")}</p></Reveal>
        <Reveal delay={0.25}>
          <button onClick={join} data-testid="join-cta-final" className="jc-bg mt-8 inline-flex items-center gap-2 font-medium uppercase tracking-wider text-sm px-8 py-4 transition-all">
            {t("join.cta_btn")} <ArrowRight className="w-4 h-4" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
